import { UserAdv } from '~/lib/types/UserAdv'
import { BackendApiRequest, BackendApiRequestWithFirebaseAuth, BackendApiRequestWithoutAuth } from '../client'

export const getCurrentUserAdv = async () => {
  const { userAdv } = await BackendApiRequest<{ userAdv: UserAdv }>({
    url: '/v1/user_advs/me',
  })
  return userAdv
}

export const registerFcmToken = async (token: string) => {
  // do not check response
  await BackendApiRequest<void>({
    url: '/v1/user_advs/me/devices',
    method: 'POST',
    data: { token: token },
  })
}

export const preSignUp = async (email: string) => {
  await BackendApiRequestWithoutAuth<void>({
    method: 'POST',
    url: '/v1/user_advs/pre_sign_up',
    data: { email: email },
  })
}

export const preSignUpComplete = async (token: string) => {
  const { email } = await BackendApiRequestWithoutAuth<{ email: string }>({
    method: 'DELETE',
    url: '/v1/user_advs/pre_sign_up',
    data: { token: token },
  })
  return email
}

type CreateUserAdvProps = {
  tel: string
  name: string
  nameFurigana?: string
}

export const createUserAdv = async (payload: CreateUserAdvProps) => {
  // on server-side, user adv info is fetch from firebase
  const { userAdv } = await BackendApiRequestWithFirebaseAuth<{ userAdv: UserAdv }>({
    method: 'POST',
    url: '/v1/user_advs',
    data: {
      ...payload,
    },
  })
  return userAdv
}

export const completePasswordReset = async (oobCode: string, newPassword: string) => {
  // 認証不要: パスワードリセットメールのリンクから遷移するため、ユーザーは未ログイン状態。
  // バックエンド側も @UseGuards なし（oobCode で本人確認）
  await BackendApiRequestWithoutAuth<void>({
    method: 'PATCH',
    url: '/v1/user_advs/me/password_reset_completed',
    data: { oobCode, newPassword },
  })
}

export const updateUserAdv = async (userAdvId: number | null | undefined, data: Record<string, unknown>) => {
  // on server-side, user adv info is fetch from firebase
  const { userAdv } = await BackendApiRequest<{ userAdv: UserAdv }>({
    method: 'PATCH',
    url: `/v1/user_advs/${userAdvId}`,
    data: {
      user_adv: data,
    },
  })
  return userAdv
}
